import { render } from "./addArticle.vue?vue&type=template&id=3ea8617d"
import script from "./addArticle.vue?vue&type=script&lang=js"
export * from "./addArticle.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__